import React, { useState } from 'react';
import { X } from 'lucide-react';
import AuthForm from './AuthForm';

const AuthModal = ({ isOpen, onClose, initialMode = 'login' }) => {
  const [mode, setMode] = useState(initialMode);

  if (!isOpen) return null;

  const handleClose = () => {
    setMode('login'); // Reset to login mode when closing
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-3 sm:p-4">
      <div className="bg-white rounded-xl sm:rounded-2xl shadow-2xl max-w-md w-full max-h-[95vh] sm:max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-4 sm:px-6 py-3 sm:py-4 flex justify-between items-center rounded-t-xl sm:rounded-t-2xl">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-br from-[#0176D3] to-[#0155A8] rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xs sm:text-sm">B</span>
            </div>
            <span className="font-semibold text-gray-900 text-sm sm:text-base">Bissa</span>
          </div>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors p-1"
          >
            <X className="w-5 h-5 sm:w-6 sm:h-6" />
          </button>
        </div>
        
        <div className="px-4 sm:px-6 py-6 sm:py-8">
          <AuthForm 
            mode={mode} 
            onToggleMode={setMode}
            onClose={handleClose}
          />
        </div>
      </div>
    </div>
  );
};

export default AuthModal;